export const blockIconsNavigationNorthEast = (
	<span className='material-symbols-outlined'>north_east</span>
);
